import type { PosicionPublica } from '../datos/index.js'

/**
 * El marcador de un match: las dos parejas y cuántas partidas lleva cada una.
 *
 * Va en la cabecera en lugar del semáforo de rondas. En un match las rondas son
 * las partidas y no se sabe cuántas van a ser: lo que se pregunta es «¿cómo
 * van?», y eso es un marcador, no un avance.
 *
 * Sale de la tabla de posiciones, que en Parejas tiene una fila por pareja y
 * cuenta solo las partidas cerradas: la que se está jugando no suma hasta que
 * termina, igual que en la tabla.
 */
export function MarcadorMatch({
  partidasAGanar,
  posiciones,
  terminado,
}: {
  partidasAGanar: number
  posiciones: readonly PosicionPublica[]
  terminado: boolean
}) {
  /* Antes de iniciar no hay tabla: el match todavía no tiene a quién marcar. */
  if (posiciones.length === 0) return null

  /* En el orden de la tabla, que pone primero a la que va ganando. */
  const parejas = posiciones.slice(0, 2)
  const ganadora = terminado ? parejas.find((p) => p.ganadas >= partidasAGanar) : undefined

  return (
    <div className="avance-bloque">
      <div className="match" aria-label="Marcador del match">
        {parejas.map((p) => (
          <div
            key={p.participanteId}
            className={`match-pareja${ganadora?.participanteId === p.participanteId ? ' ganadora' : ''}`}
          >
            <span className="match-nombre">{p.nombre}</span>
            <span className="match-fichas" aria-hidden="true">
              {Array.from({ length: partidasAGanar }, (_, i) => (
                <span key={i} className={`match-ficha${i < p.ganadas ? ' ganada' : ''}`} />
              ))}
            </span>
            <span className="match-ganadas">{p.ganadas}</span>
          </div>
        ))}
      </div>
      <p className="avance-etiqueta tenue">
        {ganadora
          ? `Ganó ${ganadora.nombre}, ${ganadora.ganadas} a ${parejas.find((p) => p !== ganadora)?.ganadas ?? 0}`
          : `Gana la primera pareja que llegue a ${partidasAGanar} ${partidasAGanar === 1 ? 'partida' : 'partidas'}`}
      </p>
    </div>
  )
}
